import { Icon, SVGIcon } from '../core/interfaces/Icon';

export enum AdsHorizontalTabsErrors {
  TAB_DOESNT_EXIST = "No tab matching prop 'activeTab' value",
}

/**
 * An interface for the horizontal Tab
 * @docs
 */
export interface HorizontalTab {
  id: string;
  icon?: Icon | SVGIcon;
  label: string;
  dismissible?: boolean;
  attributes?: any;
}

/**
 * An interface for the `TabSelectEvent` event
 * @docs
 */
export interface TabSelectEvent {
  evt: Event;
  id: string;
}

/**
 * An interface that describes the tab selection handler
 */
export type TabSelectHandler = (evt: TabSelectEvent) => void;

/**
 * An interface that describes the tab close event
 * @docs
 */
export interface TabCloseEvent {
  evt: MouseEvent;
  id: string;
}

/**
 * An interface that describes the tab close handler
 */
export type TabCloseHandler = (evt: TabCloseEvent) => void;

/**
 * An interface that describes the tab blur event
 * @docs
 */
export interface TabBlurEvent {
  evt: FocusEvent;
  id: string;
}

/**
 * An interface that describes the tab blur handler
 */
export type TabBlurHandler = (evt: TabBlurEvent) => void;

/**
 * An interface that describes the tab focus event
 * @docs
 */
export interface TabFocusEvent {
  evt: FocusEvent;
  id: string;
}

/**
 * An interface that describes the tab focus handler
 */
export type TabFocusHandler = (evt: TabFocusEvent) => void;
